var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ColumnBaseComponent } from './columnbase.component';
// @Component({
// 	moduleId: module.id.toString(),
// 	selector: '',
// 	template: '',
// 	styles: []
// })
var ColumnBaseSelectComponent = /** @class */ (function (_super) {
    __extends(ColumnBaseSelectComponent, _super);
    function ColumnBaseSelectComponent(service, baseService, cdRef) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        return _this;
    }
    ColumnBaseSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setColOptions();
        this.refSubsc = this.service.refObservable.subscribe(function (flg) {
            if (flg) {
                _this.setColOptions();
            }
        });
    };
    ColumnBaseSelectComponent.prototype.setColOptions = function () {
        if (!this.componentName || !this.col.key) {
            return;
        }
        var options = this.service.getRefOptions(this.componentName, this.col.key);
        if (options) {
            $.extend(true, this.col, { params: { options: options } });
            this.changeColOptions();
        }
    };
    ColumnBaseSelectComponent.prototype.changeColOptions = function () {
        this.setValue();
        this.cdRef.detectChanges();
    };
    ColumnBaseSelectComponent.prototype.setValue = function () {
    };
    ColumnBaseSelectComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.refSubsc) {
            this.refSubsc.unsubscribe();
        }
    };
    return ColumnBaseSelectComponent;
}(ColumnBaseComponent));
export { ColumnBaseSelectComponent };
//# sourceMappingURL=columnbase-select.component.js.map